/*
  Atelierul de Așternuturi — "Vezi mai multe" on collection pages.

  Replaces numbered pagination with a button that appends the next page into the
  existing grid. The theme's pagination stays in the DOM (hidden) so search
  engines still follow the links to every page.

  Filters and sorting re-render the grid over AJAX, which destroys our button, so
  an observer re-initialises after each of those updates.
*/
(function () {
  var LABEL = 'Vezi mai multe';
  var LOADING = 'Se încarcă…';
  var AUTO_AFTER = 2;            // taps before the grid keeps loading on scroll

  // Back-navigation memory: how many pages were appended (and whether auto-loading was on) is kept per
  // collection URL, so coming back from a product re-appends them before at-scroll-restore puts the shopper
  // back where they were. A fresh visit starts again from page 1.
  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
  var returning = nav.type === 'back_forward' || nav.type === 'reload';
  function stateKey() { return 'at-more:' + location.pathname + location.search.replace(/([?&])page=\d+&?/, '$1').replace(/[?&]$/, ''); }
  function readState() { try { return JSON.parse(sessionStorage.getItem(stateKey()) || 'null'); } catch (e) { return null; } }
  function writeState(s) { try { sessionStorage.setItem(stateKey(), JSON.stringify(s)); } catch (e) {} }
  var pending = returning ? readState() : null;
  if (!returning) { try { sessionStorage.removeItem(stateKey()); } catch (e) {} }
  var resolveReady;
  window.atMoreReady = new Promise(function (r) { resolveReady = r; });
  function ready() { if (resolveReady) { resolveReady(); resolveReady = null; } }

  function grid() { return document.querySelector('ul#product-grid'); }      // the grid IS #product-grid here
  function paginationWrap() { return document.querySelector('.pagination-wrapper'); }
  function pageOf(url) {
    var m = String(url).match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }
  // This theme's .pagination__item--next actually points BACKWARDS (on page 2 it
  // links to page 1), so never trust it — match the numbered links instead.
  function nextUrlFrom(root, current) {
    var links = root.querySelectorAll('.pagination-wrapper a[href*="page="]');
    for (var i = 0; i < links.length; i++) {
      if (pageOf(links[i].getAttribute('href')) === current + 1) return links[i].getAttribute('href');
    }
    return null;
  }

  function init() {
    var list = grid();
    if (!list || list.dataset.atMore === 'on') return;
    var current = pageOf(location.search);
    var next = nextUrlFrom(document, current);
    var wrap = paginationWrap();
    var stale = document.querySelector('.at-more');
    if (stale) stale.remove();                      // filters re-render the grid; never leave two buttons
    list.dataset.atMore = 'on';
    if (wrap) wrap.style.display = 'none';          // hidden, not removed: links stay crawlable
    if (!next) { ready(); return; }                 // last page: no button, and still no page numbers

    var holder = document.createElement('div');
    holder.className = 'at-more';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'at-more__btn button button--secondary';
    btn.textContent = LABEL;
    holder.appendChild(btn);
    (wrap ? wrap.parentNode.insertBefore(holder, wrap) : list.parentNode.appendChild(holder));

    var loading = false, taps = 0, auto = false;

    function inView() {
      var r = holder.getBoundingClientRect();
      return r.top < (window.innerHeight + 800);          // start fetching before it is reached
    }
    function maybeAuto() {
      if (auto && !loading && next && inView()) load(true);
    }
    // Belt and braces: an observer fires even when scroll events behave oddly,
    // and is re-armed after every batch because a still-visible target emits no
    // new event on its own.
    var io = null;
    function armObserver() {
      if (!auto || !('IntersectionObserver' in window)) return;
      if (io) io.disconnect();
      io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) load(true);
      }, { rootMargin: '800px 0px' });
      io.observe(holder);
    }
    function finish() {
      auto = false;
      if (io) io.disconnect();
      document.removeEventListener('scroll', maybeAuto, true);
      window.removeEventListener('resize', maybeAuto);
      holder.remove();
    }

    function load(auto, done) {
      if (loading || !next) { if (done) done(); return; }
      loading = true;
      btn.disabled = true;
      btn.textContent = LOADING;
      fetch(next, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('ul#product-grid > li');
          if (!items.length) { finish(); if (done) done(); return; }
          // Guard against appending a product twice, whatever the pagination does.
          var seen = {};
          list.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
            var h = (a.getAttribute('href') || '').split('?')[0];
            if (h) seen[h] = 1;
          });
          var frag = document.createDocumentFragment();
          items.forEach(function (li) {
            var a = li.querySelector('a[href*="/products/"]');
            var h = a ? a.getAttribute('href').split('?')[0] : null;
            if (h && seen[h]) return;
            if (h) seen[h] = 1;
            frag.appendChild(document.importNode(li, true));
          });
          list.appendChild(frag);
          current += 1;
          next = nextUrlFrom(doc, current);
          loading = false;
          writeState({ p: current, auto: auto || taps >= AUTO_AFTER });
          if (!next) { finish(); if (done) done(); return; }
          btn.disabled = false;
          btn.textContent = auto ? LOADING : LABEL;
          // The grid just got taller: re-check, and re-arm the observer.
          if (auto) setTimeout(function () { armObserver(); maybeAuto(); }, 250);
          if (done) done();
        })
        .catch(function () {                       // network hiccup: hand control back to the shopper
          loading = false;
          auto = false;                              // back to manual after a failed request
          btn.disabled = false;
          btn.textContent = LABEL;
          btn.classList.remove('at-more__btn--auto');
          if (io) io.disconnect();
          document.removeEventListener('scroll', maybeAuto, true);
          if (done) done();
        });
    }

    function enableAuto() {
      auto = true;
      btn.classList.add('at-more__btn--auto');
      // This theme scrolls <body>, not the window, so a plain window scroll
      // listener never fires. Capture on document catches it wherever it happens.
      document.addEventListener('scroll', maybeAuto, { passive: true, capture: true });
      window.addEventListener('resize', maybeAuto, { passive: true });
      armObserver();
      setTimeout(maybeAuto, 400);
    }

    btn.addEventListener('click', function () {
      taps += 1;
      load(false);
      // After two taps the shopper has shown intent: keep feeding the grid as they
      // scroll. The button stays in the DOM as the loading indicator and as the
      // fallback if a request fails, so the footer is still reachable at the end.
      if (taps >= AUTO_AFTER && !auto) enableAuto();
    });

    // Coming back from a product: re-append the pages the shopper had loaded, one after another,
    // then let at-scroll-restore jump to the saved position.
    var target = pending && pending.p > current ? pending : null;
    pending = null;
    if (!target) { ready(); return; }
    (function step() {
      if (current >= target.p || !next) {
        if (target.auto && next) { taps = AUTO_AFTER; enableAuto(); }
        ready();
        return;
      }
      load(false, step);
    })();
  }

  function boot() {
    init();
    var host = document.querySelector('#ProductGridContainer') || document.body;
    new MutationObserver(function () { init(); }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
